import { ContentNugget, ContentCompetency } from '@backrs_ui/common-ui';

export const getCompetencySlugsFromNugget = (
  currentDialogNugget: ContentNugget | undefined,
  allCompetencies: ContentCompetency[],
): string[] => {
  if (!currentDialogNugget) {
    return [];
  }

  const nuggetWithCompetencies = currentDialogNugget as typeof currentDialogNugget & {
    content_competency_ids?: number[];
  };

  return (
    nuggetWithCompetencies?.content_competency_ids
      ?.map(
        (competencyId: number) => allCompetencies.find((comp) => comp.id === competencyId)?.slug,
      )
      .filter((slug): slug is string => slug !== undefined) || []
  );
};
